import { regStepIds, eventFlows } from '../../../../../utils/eventConstants';

export function getBackDestination({ sidebarFlow, regStepId, isCampEvent, isMultiRegistrationAllowed }) {
    const returnToCampMemberSelection = isCampEvent && regStepId === regStepIds.DIVISIONS && isMultiRegistrationAllowed;

    if (sidebarFlow === regStepIds.DIVISIONS_SWITCH) {
        if (regStepId === regStepIds.DIVISIONS_ADD) {
            return { step: regStepIds.DIVISIONS_CANCEL, clearSelections: true };
        }
        if (regStepId === regStepIds.DIVISIONS_SWITCH || regStepId === regStepIds.TEAMMATE || regStepId === regStepIds.UPGRADE) {
            return { step: regStepIds.DIVISIONS_ADD };
        }
        if (regStepId === regStepIds.PAYMENT) {
            return { step: regStepIds.DIVISIONS_SWITCH };
        }
        return {};
    }

    if (sidebarFlow === eventFlows.CAMP_FLOW || returnToCampMemberSelection) {
        const isRegStepOnADivisionSelection = regStepId === regStepIds.CAMP_DIVISION_SELECTION || regStepId === regStepIds.DIVISIONS;
        return { step: isRegStepOnADivisionSelection ? regStepIds.CAMP_USER_SELECTION : regStepIds.CAMP_DIVISION_SELECTION };
    }

    if (sidebarFlow === regStepIds.CHANGE_PARTNER) {
        return { step: regStepIds.CHANGE_PARTNER };
    }

    if (sidebarFlow === regStepIds.DIVISIONS_ADD && regStepId === regStepIds.UPGRADE) {
        return { step: regStepIds.DIVISIONS_ADD };
    }

    return { step: regStepIds.DIVISIONS };
}
